import React from 'react';
import ReactDOM from 'react-dom/client';
// CSS imported here for development mode (webpack-dev-server)
// In production, also loaded via <link> tag in index.html for immediate availability
// Force cache bust - v1.0.1
import './index.css';
import './styles/wave-header.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ============================================================================
// Global Drag Detection System for Swiper Sliders
// ============================================================================
// These global event listeners prevent click events from firing during swipe gestures
// They are intentionally global and persistent to work across all sliders in the app
// This fixes the issue where clicking products while swiping would open detail pages
// Note: These listeners use passive event handlers for better scroll performance
// ============================================================================
window.dragDetected = false;
let dragStartX = 0;
let dragStartY = 0;
const dragThreshold = 3; // Reduced threshold for more responsive detection

document.addEventListener('mousedown', (e) => {
  window.dragDetected = false;
  dragStartX = e.clientX;
  dragStartY = e.clientY;
});

document.addEventListener('mousemove', (e) => {
  if (!window.dragDetected) {
    const diffX = Math.abs(e.clientX - dragStartX);
    const diffY = Math.abs(e.clientY - dragStartY);
    if (diffX > dragThreshold || diffY > dragThreshold) {
      window.dragDetected = true;
    }
  }
});

document.addEventListener('mouseup', () => {
  // Reset drag detection after a short delay to allow click events to process
  setTimeout(() => {
    window.dragDetected = false;
  }, 10); // Reduced timeout for faster response
});

// Touch event handling for mobile
document.addEventListener('touchstart', (e) => {
  if (e.touches.length > 0) {
    window.dragDetected = false;
    dragStartX = e.touches[0].clientX;
    dragStartY = e.touches[0].clientY;
  }
}, { passive: true }); // Added passive: true for better performance

document.addEventListener('touchmove', (e) => {
  if (!window.dragDetected && e.touches.length > 0) {
    const diffX = Math.abs(e.touches[0].clientX - dragStartX);
    const diffY = Math.abs(e.touches[0].clientY - dragStartY);
    if (diffX > dragThreshold || diffY > dragThreshold) {
      window.dragDetected = true;
    }
  }
}, { passive: true }); // Added passive: true for better performance

document.addEventListener('touchend', () => {
  // Reset drag detection after a short delay
  setTimeout(() => {
    window.dragDetected = false;
  }, 10); // Reduced timeout for faster response
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
